import {
  Box,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import DatePicker from '../../../../../../../../components/DatePicker/DatePicker';
import { useRootContext } from '../../../../../../../../components/RootContainer';
import { FileExcelIcon } from '../../../../../../../../components/SvgIcons/FileExcelIcon';
import { FilePdfIcon } from '../../../../../../../../components/SvgIcons/FilePdfIcon';
import { dateApiParser } from '../../../../../../../../utils/DateHelpers';
import { outputDateValue } from '../../../../../../../../utils/InputOutputDateFormat';
import { FooterExtraButtons } from '../../../../../../components/FooterButtons';
import { ReportLabel } from '../../../../../../components/ReportLabel';
import { TrialBalanceReportFormModel } from '../../models';

export const FilterForm: FC<{
  onSubmit: (data: TrialBalanceReportFormModel) => void;
  onReset: () => void;
}> = ({ onSubmit, onReset }) => {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useFormContext<TrialBalanceReportFormModel>();

  const { globalSettings } = useRootContext();

  return (
    <Box sx={{ p: 0, height: '100%', backgroundColor: 'colors.gray.o10', overflowY: 'scroll' }}>
      <Stack direction={'column'} spacing={0} sx={{ width: '100%', height: '100%' }}>
        <ReportLabel label="Trial balance report" />
        <Stack direction={'row'} spacing={0}>
          <Stack
            direction={'column'}
            spacing={2}
            sx={{
              p: 3,
            }}
          >
            <Controller
              control={control}
              name="date"
              render={({ field }) => (
                <DatePicker
                  maxDate={dateApiParser(globalSettings?.frontend_date!)}
                  value={field.value}
                  label={'Date'}
                  onChange={(date: Date) => field.onChange(outputDateValue(date))}
                  renderInput={(params: TextFieldProps) => (
                    <TextField
                      {...params}
                      size="medium"
                      variant="standard"
                      sx={{
                        width: '100%',
                      }}
                      label="Date"
                      error={Boolean(errors?.date)}
                      helperText={errors?.date?.message}
                      onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                      placeholder="mm/dd/yyyy"
                    />
                  )}
                />
              )}
            />

            <Controller
              control={control}
              name="detailed"
              render={({ field }) => (
                <FormControlLabel
                  sx={{ m: 0 }}
                  {...field}
                  checked={field.value ?? false}
                  onChange={(e, checked) => field.onChange(checked)}
                  label={
                    <Typography variant="inter16" fontWeight={500} sx={{ ml: '1rem' }}>
                      Detailed
                    </Typography>
                  }
                  control={<Switch />}
                />
              )}
            />

            <Box sx={{ height: 10 }} />
          </Stack>
        </Stack>
        {/* <FooterButtons onSubmit={handleSubmit(onSubmit)} onReset={onReset} /> */}
        <FooterExtraButtons
          onSubmit={file_type => {
            setValue('file_type', file_type);
            handleSubmit(onSubmit)();
          }}
          onReset={onReset}
          exportFileTypes={[
            {
              label: 'PDF',
              value: 'pdf',
              icon: <FilePdfIcon sx={{ width: '3rem', height: '3rem' }} />,
            },
            {
              label: 'EXCEL',
              value: 'excel',
              icon: <FileExcelIcon sx={{ width: '3rem', height: '3rem' }} />,
            },
          ]}
        />
      </Stack>
    </Box>
  );
};
